import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';
import { USE_EXISTING_NARRATIVE_REDIRECT_COMPANY_FRAGMENT } from '../useExistingNarrativeRedirect';
import { NARRATIVE_SIDEBAR_COMPANY_FRAGMENT } from '../../components/NarrativeSidebar/narrativeSidebarFragment';

const QUERY = gql(
  `
  query getNarrativeValuationCompany($companyId: String!) {
    Company(id: $companyId) {
      ...NarrativeSidebarCompanyFields
      ...UseExistingNarrativeRedirectCompanyFields
    }
  }
`,
  [
    USE_EXISTING_NARRATIVE_REDIRECT_COMPANY_FRAGMENT,
    NARRATIVE_SIDEBAR_COMPANY_FRAGMENT,
  ]
);

export const useNarrativeValuationCompany = makeGqlQuery(QUERY);
